import { Space } from "antd";
import type { ReactNode } from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

type TableRowActionLinkProps = {
  to: string;
  back?: string;
  icon?: ReactNode;
  linkLabelIntl?: string;
};

export const TableRowActionLink = ({ to, back, icon, linkLabelIntl }: TableRowActionLinkProps) => {
  return (
    <Link to={to} state={back ? { back } : undefined}>
      <Space style={{ columnGap: "5px" }}>
        {icon}
        <FormattedMessage id={linkLabelIntl} />
      </Space>
    </Link>
  );
};
